var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { Row } from "react-bootstrap";
import { Caption } from "@irati/ui/src/Labels";
import media, { minWidthMedia } from "@irati/ui/src/global/media";
import { H2 } from "@irati/ui/src/Headings";
import { Dosis } from "@irati/ui/src/global/fonts";
import AdminHeader from "../../AdminHeader/AdminHeader";
export var Div = function (props) { return React.createElement("div", __assign({}, props)); };
export var PageHeader = styled(Row)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 60px;\n"], ["\n  margin-bottom: 60px;\n"])));
export var BenefitHeader = styled(Caption)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  font-size: 18px;\n  max-width: 250px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n\n  ", "\n"], ["\n  ", "\n  font-size: 18px;\n  max-width: 250px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n\n  ",
    "\n"])), Dosis, minWidthMedia.largeDesktop(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    max-width: 400px;\n  "], ["\n    max-width: 400px;\n  "]))));
export var TitleAndCount = styled(AdminHeader)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", " {\n    ", "\n  }\n"], ["\n  ", " {\n    ",
    "\n  }\n"])), H2, media.largeDesktop(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      font-size: 38px;\n    "], ["\n      font-size: 38px;\n    "]))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
